type Props = {
    children: React.ReactNode;
};
export default function AuthLayout({ children }: Props) {
    return (
        <div className="w-full h-screen bg-white items-center mobile:bg-white">
            {children}
        </div>
    );
}